import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — an L-shaped corner base unit joining a counter run
// along X (back flush at z = -0.3) to a run along Z (back flush at x = -0.3).
// Same heights and colours as the straight kitchen-counter.
const CARCASS = "#e8e4dc";
const FRONT = "#efece6";
const WORKTOP = "#d8d5cf";
const MATTE_BLACK = "#2e2e30";

export const kitchenCounterCorner = defineModel({
  id: "kitchen-counter-corner",
  batchId: "modern",
  name: "Kitchen counter (corner)",
  tags: ["modern", "interior", "furniture", "kitchen", "storage", "counter"],
  summary: "An L-shaped corner kitchen base unit joining two counter runs.",
  tiles: { w: 1, h: 1 },
  footprint: 0.8,
  parts(): Part[] {
    return [
      // arm A — along X, back flush at z = -0.3
      { geometry: new THREE.BoxGeometry(0.94, 0.1, 0.5), color: MATTE_BLACK, position: [0, 0.05, -0.04] },
      { geometry: new THREE.BoxGeometry(1.0, 0.76, 0.56), color: CARCASS, position: [0, 0.48, -0.02] },
      // arm B — along Z toward +Z, back flush at x = -0.3
      { geometry: new THREE.BoxGeometry(0.5, 0.1, 0.2), color: MATTE_BLACK, position: [-0.04, 0.05, 0.37] },
      { geometry: new THREE.BoxGeometry(0.56, 0.76, 0.24), color: CARCASS, position: [-0.02, 0.48, 0.38] },
      // door front on arm A (facing +Z, beside the blind corner)
      { geometry: new THREE.BoxGeometry(0.2, 0.72, 0.02), color: FRONT, position: [0.37, 0.49, 0.27] },
      // door front on arm B (facing +X)
      { geometry: new THREE.BoxGeometry(0.02, 0.72, 0.2), color: FRONT, position: [0.27, 0.49, 0.38] },
      // thin bar handles
      { geometry: new THREE.BoxGeometry(0.12, 0.025, 0.02), color: MATTE_BLACK, position: [0.37, 0.8, 0.29] },
      { geometry: new THREE.BoxGeometry(0.02, 0.025, 0.12), color: MATTE_BLACK, position: [0.29, 0.8, 0.38] },
      // worktop — two pieces forming the L (top surface at 0.9)
      { geometry: new THREE.BoxGeometry(1.0, 0.04, 0.6), color: WORKTOP, position: [0, 0.88, 0] },
      { geometry: new THREE.BoxGeometry(0.6, 0.04, 0.2), color: WORKTOP, position: [0, 0.88, 0.4] },
    ];
  },
  animations: [],
});
